export default __webpack_public_path__ + "static/media/9.1b9f0e0c.png";